import React, {Component} from 'react';
import {ResponsiveChoropleth} from '@nivo/geo'
import canada from './canada_provinces'
import {Typography} from "@material-ui/core";

class CasesMap extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /* -------- LIFECYCLE METHODS -------- */


    /* -------- FUNCTIONS -------- */


    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    renderTooltip = (props) => {
        let {data} = props.feature

        if(data) {
            return <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                backgroundColor: '#fff',
                borderRadius: '4px',
                padding: '8px',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)'
            }}>
                <Typography variant={'h6'}>{data.name}</Typography>
                <div>Confirmed: {Number(data.confirmed).toLocaleString('en')}</div>
                <div>Recovered: {Number(data.recovered).toLocaleString('en')}</div>
                <div>Deaths: {Number(data.deaths).toLocaleString('en')}</div>
            </div>
        } else {
            return null
        }
    }

    layersFunc = () => {
        let mediaBreakPoint = this.props.dimensions[0];

        if(mediaBreakPoint <= 460) {
            return <svg >
                <g pointerEvents="none">
                    <rect x="52" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="55" y="189" fontSize={8} fill="#000">BC</text>
                </g>
                <g pointerEvents="none">
                    <rect x="89" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="92" y="189" fontSize={8} fill="#000">AB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="126" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="129" y="189" fontSize={8} pointerEvents="none" fill="#000">SK</text>
                </g>
                <g pointerEvents="none">
                    <rect x="154" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="157" y="189" fontSize={8} fill="#000">MB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="191" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="194" y="189" fontSize={8} fill="#000">ON</text>
                </g>
                <g pointerEvents="none">
                    <rect x="251" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="254" y="189" fontSize={8} fill="#000">QC</text>
                </g>
                <g pointerEvents="none">
                    <rect x="271" y="233" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="274" y="241" fontSize={8} fill="#000">NB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="301" y="233" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="304" y="241" fontSize={8} fill="#000">NS</text>
                </g>
                <g pointerEvents="none">
                    <rect x="291" y="218" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="294" y="226" fontSize={8} fill="#000">PEI</text>
                </g>
                <g pointerEvents="none">
                    <rect x="296" y="181" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="299" y="189" fontSize={8} fill="#000">NL</text>
                </g>
                <g pointerEvents="none">
                    <rect x="20" y="120" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="23" y="128" fontSize={8} fill="#000">YT</text>
                </g>
                <g pointerEvents="none">
                    <rect x="90" y="120" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="93" y="128" fontSize={8} fill="#000">NU</text>
                </g>
                <g pointerEvents="none">
                    <rect x="154" y="120" width="16" height="10" fill="#fff" rx={2}/>
                    <text x="157" y="128" fontSize={8} fill="#000">NT</text>
                </g>
            </svg>
        }

        if(mediaBreakPoint <= 856) {
            return <svg >
                <g pointerEvents="none">
                    <rect x="76" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="80" y="179" fontSize={10} fill="#000">BC</text>
                </g>
                <g pointerEvents="none">
                    <rect x="128" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="132" y="179" fontSize={10} fill="#000">AB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="170" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="174" y="179" fontSize={10} pointerEvents="none" fill="#000">SK</text>
                </g>
                <g pointerEvents="none">
                    <rect x="206" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="210" y="179" fontSize={10} fill="#000">MB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="255" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="259" y="179" fontSize={10} fill="#000">ON</text>
                </g>
                <g pointerEvents="none">
                    <rect x="330" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="334" y="179" fontSize={10} fill="#000">QC</text>
                </g>
                <g pointerEvents="none">
                    <rect x="350" y="220" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="354" y="231" fontSize={10} fill="#000">NB</text>
                </g>
                <g pointerEvents="none">
                    <rect x="380" y="240" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="384" y="251" fontSize={10} fill="#000">NS</text>
                </g>
                <g pointerEvents="none">
                    <rect x="380" y="210" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="384" y="221" fontSize={10} fill="#000">PEI</text>
                </g>
                <g pointerEvents="none">
                    <rect x="380" y="168" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="384" y="179" fontSize={10} fill="#000">NL</text>
                </g>
                <g pointerEvents="none">
                    <rect x="36" y="90" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="40" y="101" fontSize={10} fill="#000">YT</text>
                </g>
                <g pointerEvents="none">
                    <rect x="120" y="90" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="124" y="101" fontSize={10} fill="#000">NU</text>
                </g>
                <g pointerEvents="none">
                    <rect x="210" y="90" width="24" height="14" fill="#fff" rx={2}/>
                    <text x="214" y="101" fontSize={10} fill="#000">NT</text>
                </g>
            </svg>
        }

        return <svg  width={1200} height={427} >
            <g pointerEvents="none">
                <rect x="156" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="160" y="300" fontSize={12} fill="#000">BC</text>
            </g>
            <g pointerEvents="none">
                <rect x="246" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="250" y="300" fontSize={12} fill="#000">AB</text>
            </g>
            <g pointerEvents="none">
                <rect x="316" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="320" y="300" fontSize={12} pointerEvents="none" fill="#000">SK</text>
            </g>
            <g pointerEvents="none">
                <rect x="386" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="390" y="300" fontSize={12} fill="#000">MB</text>
            </g>
            <g pointerEvents="none">
                <rect x="477" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="480" y="300" fontSize={12} fill="#000">ON</text>
            </g>
            <g pointerEvents="none">
                <rect x="596" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="600" y="300" fontSize={12} fill="#000">QC</text>
            </g>
            <g pointerEvents="none">
                <rect x="651" y="378" width="24" height="14" fill="#fff" rx={2}/>
                <text x="655" y="390" fontSize={12} fill="#000">NB</text>
            </g>
            <g pointerEvents="none">
                <rect x="676" y="408" width="24" height="14" fill="#fff" rx={2}/>
                <text x="680" y="420" fontSize={12} fill="#000">NS</text>
            </g>
            <g pointerEvents="none">
                <rect x="671" y="380" width="24" height="14" fill="#fff" rx={2}/>
                <text x="685" y="392" fontSize={12} fill="#000">PEI</text>
            </g>
            <g pointerEvents="none">
                <rect x="676" y="288" width="24" height="14" fill="#fff" rx={2}/>
                <text x="680" y="300" fontSize={12} fill="#000">NL</text>
            </g>
            <g pointerEvents="none">
                <rect x="76" y="138" width="24" height="14" fill="#fff" rx={2}/>
                <text x="80" y="150" fontSize={12} fill="#000">YT</text>
            </g>
            <g pointerEvents="none">
                <rect x="386" y="138" width="24" height="14" fill="#fff" rx={2}/>
                <text x="390" y="150" fontSize={12} fill="#000">NU</text>
            </g>
            <g pointerEvents="none">
                <rect x="266" y="138" width="24" height="14" fill="#fff" rx={2}/>
                <text x="270" y="150" fontSize={12} fill="#000">NT</text>
            </g>
        </svg>
    }


    render() {


        if(this.props.data) {
            let domainMax = Math.max.apply(Math, this.props.data.map(function(o) { return o.value; }))
            domainMax = Math.ceil(domainMax/100)*100
            let domain = [0, domainMax]
            let mediaBreakPoint = this.props.dimensions[0]
            if(mediaBreakPoint <= 460) {
                return <div className='section' style={{height: 300}}>
                    <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Cases Map</Typography>
                    <div style={{
                        display: 'flex',
                        height: 272,
                        width: 336,
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 'auto',
                        marginLeft: 'auto'
                    }}>
                        <ResponsiveChoropleth
                            data={this.props.data}
                            features={canada.features}
                            layers={['graticule', 'features', this.layersFunc]}
                            margin={{top: 0, right: 0, bottom: 0, left: 0}}
                            colors="reds"
                            domain={domain}
                            label="properties.name"
                            projectionTranslation={[1.60, 1.58]}
                            projectionRotation={[0, 0, 0]}
                            projectionScale={218}
                            fillColor={"#eeeeee"}
                            borderWidth={0.5}
                            borderColor="#333333"
                            unkownColor="#666"
                            valueFormat={(v) => parseInt(v)}
                            tooltip={this.renderTooltip}
                            legends={[
                                {
                                    anchor: 'bottom-left',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 1,
                                    translateY: -24,
                                    itemsSpacing: 0,
                                    itemWidth: 80,
                                    itemHeight: 18,
                                    itemDirection: 'left-to-right',
                                    itemTextColor: '#444444',
                                    itemOpacity: 0.85,
                                    symbolSize: 13
                                }
                            ]}
                        />
                    </div>
                </div>
            }
            if(mediaBreakPoint <= 856) {
                return <div className='section' style={{height: 300}}>
                    <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Cases Map</Typography>
                    <div style={{
                        display: 'flex',
                        height: 272,
                        width: 450,
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 'auto',
                        marginLeft: 'auto'
                    }}>
                        <ResponsiveChoropleth
                            data={this.props.data}
                            features={canada.features}
                            layers={['graticule', 'features', this.layersFunc]}
                            margin={{top: 0, right: 0, bottom: 0, left: 0}}
                            colors="reds"
                            domain={domain}
                            label="properties.name"
                            projectionTranslation={[1.55, 1.78]}
                            projectionRotation={[0, 0, 0]}
                            projectionScale={280}
                            fillColor={"#eeeeee"}
                            borderWidth={0.5}
                            borderColor="#333333"
                            unkownColor="#666"
                            valueFormat={(v) => parseInt(v)}
                            tooltip={this.renderTooltip}
                            legends={[
                                {
                                    anchor: 'bottom-left',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 1,
                                    translateY: -24,
                                    itemsSpacing: 0,
                                    itemWidth: 80,
                                    itemHeight: 18,
                                    itemDirection: 'left-to-right',
                                    itemTextColor: '#444444',
                                    itemOpacity: 0.85,
                                    symbolSize: 13
                                }
                            ]}
                        />
                    </div>
                </div>
            } else {
                return <div className='section' style={{height: 500}}>
                    <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Cases Map</Typography>
                    <div style={{
                        display: 'flex',
                        height: 472,
                        width: '100%',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <ResponsiveChoropleth
                            data={this.props.data}
                            features={canada.features}
                            layers={['graticule', 'features', 'legends', this.layersFunc]}
                            margin={{top: 0, right: 0, bottom: 0, left: 0}}
                            colors="reds"
                            domain={domain}
                            label="properties.name"
                            projectionTranslation={[1.55, 1.78]}
                            projectionRotation={[0, 0, 0]}
                            projectionScale={485}
                            fillColor={"#eeeeee"}
                            borderWidth={0.5}
                            borderColor="#333333"
                            unkownColor="#666"
                            valueFormat={(v) => parseInt(v)}
                            tooltip={this.renderTooltip}
                            legends={[
                                {
                                    anchor: 'bottom-left',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 1,
                                    translateY: -24,
                                    itemsSpacing: 0,
                                    itemWidth: 80,
                                    itemHeight: 18,
                                    itemDirection: 'left-to-right',
                                    itemTextColor: '#444444',
                                    itemOpacity: 0.85,
                                    symbolSize: 13
                                }
                            ]}
                        />
                    </div>
                </div>
            }
        } else {
            return <div/>
        }
    }
}

export default CasesMap